/** 关联作品模块 CDN 图标（与 App 端一致） */
export const RELATED_WORK_ASSETS = {
  settingRowIcon:
    'https://static.zaohaowu.com/image-mcp-static/related-work-link-doc_af4fe2933cade4a3bbb3af692a0d2c07.svg',
  popupTipIcon:
    'https://static.zaohaowu.com/image-mcp-static/related-work-popup-tip_1786069bd8442b9d1ce7c45d966411fc.png',
  popupCloseIcon:
    'https://static.zaohaowu.com/image-mcp-static/related-work-popup-close_dcc9203d03baa09a6a17ce13bc6408cb.png',
  gridCheckboxSelected:
    'https://static.zaohaowu.com/image-mcp-static/related-work-checkbox-selected_2de2b5a53433b72d242ae711aa476103.svg',
  gridCheckboxUnchecked:
    'https://static.zaohaowu.com/image-mcp-static/related-work-checkbox-unchecked_c75950bde3bc8005788081db74beb402.svg',
  gridVideoPlayIcon:
    'https://static.zaohaowu.com/image-mcp-static/media-play-icon_1b28e37c2e389bd6fb10c774847453f5.png'
} as const

export const STORAGE_KEYS = {
  RELATED_WORK_GUIDE_SHOWN: 'related_work_guide_shown',
  RELATED_WORK_RULE_TIP_SHOWN: 'related_work_rule_tip_shown'
} as const

export const PAGE_SIZE = 20

/** 关联作品引导气泡自动隐藏时长（ms） */
export const RELATED_WORK_GUIDE_DURATION = 5000
